export default __webpack_public_path__ + "static/media/dapps3.32593e66.jpg";